import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import _ from 'lodash'

import { ENTITY_TYPE } from '../../../../../../../../../global/constants'

import { LOCALE_PREFIX, EXTERNAL_LINKS } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class ExternalDesk extends Component {
    static propTypes = {
        entity: PropTypes.object,
        selectedLanguage: PropTypes.string.isRequired,
    }

    getUrl = (link) => {
        const url = _.get(link, 'url', '')
        const postfix = _.get(EXTERNAL_LINKS, 'links.postfix')

        if (_.get(link, 'withoutPostfix', false)) url.concat(postfix)

        return url
    }

    handleButtonClick = (_url) => {
        const { entity, selectedLanguage } = this.props

        const type = entity.get('type', null)
        const regNbr = entity.getIn([type, 'regNbr'], '')
        const url = _url.replace('{regNbr}', regNbr).replace('{selectedLanguage}', selectedLanguage)

        window.open(url, '_blank')
    }

    render() {
        const { entity } = this.props
        const entCountry = entity ? entity.getIn(['country', 'iso2']) : null
        const entType = entity ? entity.get('type') : null
        let items = []
        if (entType && entType !== ENTITY_TYPE.NATURAL_PERSON) {
            items = _.get(EXTERNAL_LINKS, `items.${entCountry}`)
                ? _.get(EXTERNAL_LINKS, `items.${entCountry}`)
                : EXTERNAL_LINKS.items.other
        } else {
            items = EXTERNAL_LINKS.items.other
        }
        const links = _.get(EXTERNAL_LINKS, 'links.items', {})

        return (
            <div className={'report-external-desk'}>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                </div>
                <div className={'content'}>
                    {_.map(items, (item) => {
                        const link = _.find(links, { key: item })

                        return link ? (
                            <div
                                key={`external-link-item-${_.get(link, 'key')}`}
                                className={'content-row'}
                                onClick={() => this.handleButtonClick(this.getUrl(link))}
                            >
                                <div className={classNames('item', 'external-link', _.get(link, 'key'))} />
                                <FormattedMessage id={`${LOCALE_PREFIX}.${_.get(link, 'key')}`} />
                            </div>
                        ) : null
                    })}
                </div>
            </div>
        )
    }
}
